import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
    window.location.reload();
  };

  const decline = () => {
    localStorage.setItem("cookie_consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[90] bg-gray-100 border-t border-gray-200 p-4 md:p-5"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-sm text-gray-600 text-center md:text-left">
          Ez az oldal sütiket (cookie-kat) használ a statisztikai célú méréshez (Google Tag Manager, PostHog).
          A hozzájárulással segítesz a szolgáltatás fejlesztésében. Részletek:{" "}
          <Link to="/adatkezeles" className="text-violet-600 underline hover:text-violet-600">
            Adatkezelési tájékoztató
          </Link>
        </p>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            data-testid="cookie-decline"
            onClick={decline}
            className="px-4 py-2 text-sm text-gray-500 hover:text-gray-900 border border-gray-300 rounded-sm hover:border-gray-400 transition-colors"
          >
            Elutasítom
          </button>
          <button
            data-testid="cookie-accept"
            onClick={accept}
            className="px-5 py-2 text-sm font-bold bg-gradient-to-r from-blue-600 to-violet-600 hover:from-blue-500 hover:to-violet-500 text-white rounded-sm glow-blue transition-all"
          >
            Elfogadom
          </button>
        </div>
      </div>
    </div>
  );
}
